import request from '@/common/api/request'
// ----------------积分明细接口--------------------
const BASEPATH = '/lishui-gov'
/**
 *积分明细列表
 * @param {*} params
 * @returns
 */
export const getEntList =  params => request.get(BASEPATH + '/pointInfo/getEntList', { params })

/**
 *积分明细-企业明细
 * @param {*} params
 * @returns
 */
export const getEntInfoList =  params => request.get(BASEPATH + '/pointInfo/getEntInfoList', { params })

/**
 *积分明细-企业用户
 * @param {*} params
 * @returns
 */
export const getEntUserList =  params => request.get(BASEPATH + '/pointInfo/getEntUserList', { params })

/**
 *积分明细-用户明细
 * @param {*} params
 * @returns
 */
export const getUserDetail =  params => request.get(BASEPATH + '/pointInfo/getUserDetail', { params })

/**
 *积分明细-修改
 * @param {*} params
 * @returns
 */
export const updatePointEnt =  params => request.get(BASEPATH + '/pointInfo/updatePointEnt', { params })

/**
 *企业信息抬头
 * @param {*} params
 * @returns
 */
export const getEntDetail =  params => request.get(BASEPATH + '/pointInfo/getEntDetail', { params })

